import { render } from "./esim-notify.vue?vue&type=template&id=2a92f618&scoped=true"
import script from "./esim-notify.vue?vue&type=script&lang=js"
export * from "./esim-notify.vue?vue&type=script&lang=js"

import "./esim-notify.vue?vue&type=style&index=0&id=2a92f618&scoped=true&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a92f618"]])

export default __exports__